import { render } from "./PaginationBar.vue?vue&type=template&id=ff277300&scoped=true"
import script from "./PaginationBar.vue?vue&type=script&lang=js"
export * from "./PaginationBar.vue?vue&type=script&lang=js"

import "./PaginationBar.vue?vue&type=style&index=0&id=ff277300&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff277300"]])

export default __exports__